export type WarehouseEvent = 'receiving' | 'shrinkage' | 'adjustment';

type TriggerRule = {
  id: string;
  minNumberOfEvents: number;
  daysForRetrigger: number;
};

export const feedbackToastTriggerRules: Record<WarehouseEvent, TriggerRule> = {
  receiving: { id: 'receiving-feedback', minNumberOfEvents: 8, daysForRetrigger: 14 },
  shrinkage: { id: 'shrinkage-feedback', minNumberOfEvents: 4, daysForRetrigger: 30 },
  adjustment: { id: 'adjustment-feedback', minNumberOfEvents: 5, daysForRetrigger: 30 },
};
